/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmTPNCode = "BRONZE" | "GOLD" | "LEVEL_0" | "LEVEL_1" | "LEVEL_2" | "PLATINUM" | "SILVER" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileStatusModule_tradeFirm$ref: FragmentReference;
export type ProfileStatusModule_tradeFirm = {|
  +serviceId: ?string,
  +profileStatus: ?DesignProfileStatus,
  +pointsNeededToLevelUp: ?string,
  +tpnRole: ?{|
    +code: ?TradeFirmTPNCode
  |},
  +publicProfile: ?{|
    +urlLabel: ?string,
    +designProjectsCount: ?number,
  |},
  +$refType: ProfileStatusModule_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileStatusModule_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "profileStatus",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pointsNeededToLevelUp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tpnRole",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmTPNRole",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "designProjectsCount",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6508dddf56e4726b1bc1a33a8cb7c9af';
module.exports = node;
